export default __webpack_public_path__ + "static/media/Beastmaster's Tanned Choker.68914750.jpg";